module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAASCAQAAAD4MpbhAAABSklEQVQYGXXBPUgUABjH4b+zSo5+UDi4OIkhuDip1BRtCn2Ak6tD4iLcZIMI0nLe+3tPOzhEDreg6cCgIeJEyC0XRVFPMRWtzsWut7uG4w70eVTPR9m2Ed3HnhG2RfhT3WW5h/ApyaeJ5R7Vo8OnbJUSZ/qPImW+2UKqW1We4Iof9pVgh0t2uWaPn5bhgN+ekMQfX5OS7Zxkm/01721kpZMTVbBESOKLr0ksUlYNwaxEjk1JnrCt9DDBrGpsgbBxivZKUqaNW8LH1MCeE3xXVbKFvwSP1YBBgl1VMeMFf0nwRDXMETZJkReS+ERO4iPnqiF4I7HuBUnceD6aVlq5TD70MeZT/TZAURX2jpDk05xyzWd+sc8FRxxzTHieQ8rMqyrb7BPkCLZVkeoivMAH3lqf6jFEeEKyDfZ0N4YISpR5oPukez3PIzX4B3dJvtw4j+8IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/common/assets/looking.png
// module id = pBwy
// module chunks = 104